export const getNotificationsSelector = state => state.notifications;